import utils from "@/utils/utils";
import $api from "@/api/main"
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { onMounted, computed, reactive, toRefs, onActivated } from "vue";
import { baseURL, privewURL } from '@/utils/request';
import { Base64 } from 'js-base64';

export function detailHooks(statusMethods?: any): any {
    const route: any = useRoute();
    const router: any = useRouter();

    // 获取小数位数
    const getMaxDecimalLength = function (...val:any){
        // 最大小数位长度
        let maxDecimalLength = 0;
        val.forEach((x:any) => {
            const strVal = x.toString(),
                dotIndex = strVal.indexOf('.')
            if (dotIndex > -1) {
                // 获取当前值小数位长度
                const curDecimalLength = strVal.length - 1 - dotIndex
    
                if (curDecimalLength > maxDecimalLength) {
                    maxDecimalLength = curDecimalLength
                }
            }
        })
        return maxDecimalLength
    }
    
    const pageStatus: any = reactive({
        // 当前页面路由状态state 字符串
        state: "",

        // 当前页面路由参数
        query: {},

        // utils
        utils: utils,

        // loading
        loading: false,

        // 税率字典
        TAX_RATE: {
            "01": 0.09,
            "02": 0.03,
            "03": 0.13,
            "04": 0.01,
            "05": 0.06,
            "06": 0,
        },

        // 获取当前用户
        USER_CODE: utils.$cookie.getCookie("hxUserCode"),

        // 是否是我审核
        CAN_APPROVE: false,

        // 添加返回true
        ADD: computed(() => {
            return ["add"].includes(pageStatus.state)
        }),
        // 是否可以重新申请
        CANREAPPLY: false,

        // 添加或者是修改 状态返回true
        ADD_EDIT: computed(() => {
            return ["add", "edit", "canApply"].includes(pageStatus.state)
        }),

        // 添加或者是审核 状态返回true
        EDIT_AUTH: computed(() => {
            return ["edit", "auth"].includes(pageStatus.state)
        }),
        // && ["01", "02"].includes(pageStatus.FLOW_STATUS);
        // 审核拒绝
        REJECT: computed(() => {
            return ["canApply"].includes(pageStatus.state)
        }),

        // 审核 状态返回true
        AUTH: computed(() => {
            return ["auth"].includes(pageStatus.state);
        }),

        // 修改状态 返回 true
        EDIT: computed(() => {
            return ["edit"].includes(pageStatus.state);
        }),

        // 查看状态 返回 true
        LOOK: computed(() => {
            return ["look"].includes(pageStatus.state);
        }),

        // 流程状态
        FLOW_STATUS: "00"
    })

    const DIC: any = {
        MESSAGE: {
            'ADD_EDIT_SUCC': "数据提交成功！",
            'AUTH_SUCC': "数据审核成功！",
            'ADD_EDIT_FAIL': "数据提交失败！",
            'AUTH_FAIL': "数据审核失败！",
        }
    }

    const methods: any = {
        // 不含税单价计算方法
        noTaxPriceFunc: (tax = 0, price = 0, point = 3) => {
            return ((price * 100000) / (1 + tax) / 100000).toFixed(point)
        },
        // 不含税总价方法
        noTaxTotalPriceFunc: (tax = 0, price = 0, num = 0, point = 3) => {
            return (((price * 100000) / (1 + tax) / 100000) * num).toFixed(point)
        },
        // 含税单价计算方法
        taxPriceFunc: (tax = 0, price = 0, point = 3) => {
            return ((price * 100000) * (1 + tax) / 100000).toFixed(point)
        },
        // 含税总价方法
        taxTotalPriceFunc: (price = 0, num = 0, point = 3) => {
            return ((price * 100000 * num) / 100000).toFixed(point)
        },

        // 税额计算方法
        taxAmountFunc: (taxTotalPrice: number, noTaxTotalPrice: number, point = 3) => {
            return (((taxTotalPrice * 100000) - (noTaxTotalPrice * 100000)) / 100000).toFixed(point);
        },

        getUploadResultFn: (form: any, newValue: any, param: string | string[]) => {
            switch (true) {
                case param instanceof Array: {
                    (param as []).forEach((el: any, i: number) => {
                        form[param[i]] = newValue[i] && newValue[i].fileId || ""
                    })
                    return true
                }
                case typeof param == 'string': {
                    form[param as string] = newValue[0] && newValue[0].fileId || ""
                    return true
                }
            }
        },
        // 加法进度控制
        add:(...val:any) => {
            let sum = 0;
            const maxDecimalLength = getMaxDecimalLength(...val)
        
            val.forEach((x:any, index:any) => {
                // 所有数值转为整数计算
                sum += Math.round(x * Math.pow(10, maxDecimalLength))
            })
        
            return sum / Math.pow(10, maxDecimalLength)
        },

        // 流程执行方法
        flowAction: (interfaceName: string, params: any, cofig: any, succFunc?: any) => {
            return new Promise((resolve, reject) => {
                pageStatus.loading = true;
                $api[interfaceName](params)
                    .then(() => {
                        ElMessage.success({
                            message: (cofig.succMsg || DIC.MESSAGE[cofig.succMsgType]),
                            type: "success",
                        });

                        if (typeof succFunc == 'function') {
                            setTimeout(() => {
                                succFunc(router)
                                pageStatus.loading = false;
                                resolve(true)
                            }, 2000)
                        } else {
                            pageStatus.loading = false;
                            resolve(true)
                        }
                    })
                    .catch(() => {
                        pageStatus.loading = false;
                        // ElMessage.error(cofig.failMsg || DIC.MESSAGE[cofig.failMsgType]);
                        reject(false)
                    })
            })
        },

        // 判断是否是我创建的并且是拒绝状态或者退回状态
        canApply: (createdBy: any, flowStatus: any) => {
            pageStatus.REJECT = pageStatus.USER_CODE == createdBy && ["03", "04", "06"].includes(flowStatus)
        },


        exportFn: (interfaceName: string, params: any, cofig: any) => {
            return new Promise((resolve, reject) => {
                pageStatus.loading = true;
                $api[interfaceName](params)
                    .then((res: Array<never>) => {
                        switch (cofig.type || "exc") {
                            case "exc": {
                                utils.downExcel(res, cofig.text, false);
                                break;
                            }
                            case "pdf": {
                                utils.pdfDow(res, cofig.text);
                                break;
                            }
                        }
                        ElMessage.success({
                            message: `导出成功！`,
                            type: 'success'
                        });
                        pageStatus.loading = false;
                        return resolve(true);
                    })
                    .catch(() => {
                        pageStatus.loading = false;
                        ElMessage.error('导出失败！');
                        return reject(false)
                    })
            })
        },

        // 验证表格组件方法
        validTabel: (tableRef: any, msg: string, required = true) => {
            return new Promise((resolve, reject) => {
                if (required && !tableRef.value.getTableData().tableData.length) {
                    reject("请填写" + msg)
                }
                tableRef.value.validate(true)
                    .then((res:any) => {
                        if(res){
                            return reject(msg + "验证不通过")
                        }else{
                            return resolve(true)
                        }
                    })
                    .catch(() => {
                        setTimeout(() => {
                            tableRef.value.clearValidate()
                        }, 8000)
                        return reject(msg + "验证不通过")
                    })
            }).catch((err: any) => {
                ElMessage.warning(err || '验证异常');
            })
        },

        // 根据加身份证号码计算年龄
        getAge: (identityCard: string) => {
            identityCard = identityCard + ""
            let strBirthday = ""
            const len = (identityCard + "").length;
            if (len == 0 || len != 18) {
                return "--"
            }
            if (len == 18) {
                strBirthday = identityCard.substr(6, 4) + identityCard.substr(10, 2) + identityCard.substr(12, 2);
            }

            let returnAge;
            const birthYear: any = strBirthday.slice(0, 4);
            const birthMonth: any = strBirthday.slice(4, 6);
            const birthDay: any = strBirthday.slice(6);

            const d = new Date();
            const nowYear: any = d.getFullYear();
            const nowMonth: any = d.getMonth() + 1;
            const nowDay: any = d.getDate();

            if (nowYear == birthYear) {
                returnAge = 0;//同年 则为0岁
            }
            else {
                const ageDiff = nowYear - birthYear; //年之差
                if (ageDiff > 0) {
                    if (nowMonth == birthMonth) {
                        const dayDiff = nowDay - birthDay;//日之差
                        if (dayDiff < 0) {
                            returnAge = ageDiff - 1;
                        }
                        else {
                            returnAge = ageDiff;
                        }
                    }
                    else {
                        const monthDiff = nowMonth - birthMonth;//月之差
                        if (monthDiff < 0) {
                            returnAge = ageDiff - 1;
                        }
                        else {
                            returnAge = ageDiff;
                        }
                    }
                }
                else {
                    returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
                }
            }

            return returnAge;//返回周岁年龄
        }
    }

    onActivated(async () => {
        const taxRate = await $api.getDir("TAX_CALCULATION_METHOD");
        taxRate.forEach((item:any)=>{
            pageStatus.TAX_RATE[item.dataValue] = (item.dataLabel.replace('%',''))/100;
        });
        pageStatus.state = route.meta.state;
        pageStatus.query = route.query;
        // 执行状态初始函数
        statusMethods &&
            statusMethods[pageStatus.state] &&
            statusMethods[pageStatus.state].init &&
            statusMethods[pageStatus.state].init(pageStatus.query, utils, pageStatus)
    })
    // onMounted(async () => {
    //     const taxRate = await $api.getDir("TAX_CALCULATION_METHOD");
    //     taxRate.forEach((item:any)=>{
    //         pageStatus.TAX_RATE[item.dataValue] = (item.dataLabel.replace('%',''))/100;
    //     });
    //     pageStatus.state = route.meta.state;
    //     pageStatus.query = route.query;
    //     // 执行状态初始函数
    //     statusMethods &&
    //         statusMethods[pageStatus.state] &&
    //         statusMethods[pageStatus.state].init &&
    //         statusMethods[pageStatus.state].init(pageStatus.query, utils, pageStatus)
    // })

    return {
        ...toRefs(pageStatus),
        methods: methods,
    }
}

export function listsHooks(form: any, apiName: string, cb?: any): any {
    const page: any = reactive({
        form: Object.assign({
            pageNum: 1,
            pageSize: form.pageSize || 10,
            'orders[0].asc': false,
        }, form),
        result: [],
    })

    const methods = {
        /**
         * @description 重置分页
         */
        resetPaging: () => {
            page.form.pageNum = 1;
            page.form.pageSize = form.pageSize || 10;
        },

        /**
         * @description 重置表单数据
         */
        resetFormRequest: (filter = []) => {
            Object.keys(page.form).forEach((field: string) => {
                if (![...filter, 'pageNum', 'pageSize', 'orders[0].asc'].includes(field)) {
                    switch (true) {
                        case page.form[field] instanceof Array:
                            page.form[field] = []
                            break;

                        default:
                            page.form[field] = ""
                    }
                }
            })
            methods.request()
        },

        /**
         * @description 发送请求
         */
        request: (flag = true, success?: any) => {
            flag && methods.resetPaging();
            $api[apiName](page.form).then((result: any) => {
                cb && cb(result);
                page.result = result;
                typeof success == "function" && success()
            })
        },

        /**
         * @description 分页
         */
        handlePageChange: ({ currentPage, pageSize }: { currentPage: number, pageSize: number }) => {
            page.form.pageNum = currentPage;
            page.form.pageSize = pageSize;
            methods.request(false)
        }
    }
    return {
        ...toRefs(page),
        ...methods
    }
}

export function applyUserHooks() {
    const data: any = reactive({
        tree: [],
    })

    const filter = (
        tree: any[],
        pathArray: any[],
        indexs: any[]
    ) => {
        for (let index = 0; index < tree.length; index++) {
            if (tree[index].selectable == false && !tree[index].children) {
                data.tree[index].disabled = true
            }
            else {
                if (data.tree[index]) data.tree[index].disabled = false
            }
            if (tree[index].children) {
                filter(tree[index].children, pathArray, indexs);
            }
            pathArray.pop();
            indexs.pop();
        }
    };

    onMounted(async () => {
        data.tree = await $api.getStaffTree();
        filter(data.tree, [], []);
    })

    return {
        ...toRefs(data),
    }
}

export function interfaceHooks(apis: any) {
    const factoryInterface: any = {}
    apis.forEach((apiNmae: string) => {
        factoryInterface[apiNmae] = $api[apiNmae]
    })
    return {
        ...factoryInterface
    }
}


export function flowHooks() {
    const flowAction = (interfaceName: string, params: any, cofig: any) => {
        return new Promise((resolve, reject) => {
            const {
                confirmText = `是否确定${cofig.text}?`,
                type = 'warning',
                center = true,
                cancelButtonText = '取消',
                confirmButtonText = '确定',
            } = cofig

            ElMessageBox.confirm(confirmText, '提示', {
                type,
                center,
                cancelButtonText,
                confirmButtonText
            }).then(() => {

                $api[interfaceName](params)
                    .then(() => {
                        ElMessage.success({
                            message: `${cofig.text}，执行成功！`,
                            type: 'success'
                        });
                        resolve(true)
                    })
                    .catch(() => {
                        ElMessage.error(`${cofig.text}，执行失败！`);
                        reject(false)
                    })

            }).catch(() => {
                ElMessage('已取消执行！');
                reject(false)
            })
        })
    }

    const exportFn = (interfaceName: string, params: any, cofig: any) => {
        return new Promise((resolve, reject) => {
            $api[interfaceName](params)
                .then((res: Array<never>) => {
                    switch (cofig.type || "exc") {
                        case "exc": {
                            utils.downExcel(res, cofig.text, false);
                            break;
                        }
                        case "pdf": {
                            utils.pdfDow(res, cofig.text);
                            break;
                        }
                    }
                    ElMessage.success({
                        message: `导出成功！`,
                        type: 'success'
                    });
                    return resolve(true);
                })
                .catch(() => {
                    ElMessage.error('导出失败！');
                    reject(false)
                })
        })
    }
    const previewFn = (fileId: any, fileName: string) => {
        const fileUrl = `${baseURL}public/file/${fileId}?token=${utils.$cookie.getCookie(utils.$tokenStr)}`;

        const previewUrl = `${fileUrl}&fullfilename=${new Date().getTime() + fileName.substr(fileName.lastIndexOf('.'))}`;

        window.open(`${privewURL}onlinePreview?url=${encodeURIComponent(Base64.encode(previewUrl))}`)
    }

    return {
        flowAction,
        exportFn,
        previewFn
    }

}